import { Routes } from '@angular/router';
import { LoginGmailComponent } from './components/login-gmail/login-gmail.component';
import { DynamicLoaderComponent } from './components/dynamic-loader/dynamic-loader.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { AdminComponent } from './components/admin/admin.component';
import { AppHomeComponent } from './components/app-home/app-home.component';
import { OcrPreviewComponent } from './components/ocr-preview/ocr-preview.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'app', component: DynamicLoaderComponent, canActivate: [authGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] },
  { path: 'ocr-preview', component: OcrPreviewComponent },
  { path: '**', redirectTo: '' }
];
